import {Features} from '@mail/features';

import injector from './injector';

const features: Partial<Features> = {
	has() {
		return null;
	},

	get() {
		return null;
	},
};

const getFeatures = () => injector.get('features') || features;

export const getFeatureData = (featureName, dafaultValue) => {
	const features = getFeatures();

	if (features.has(featureName)) {
		const value = features.get(featureName).data;

		if (value) {
			return value;
		}
	}

	return dafaultValue;
};

export const filterURL = (url, defaultData, params) => getFeatures().getAsURL(url, defaultData, params);

export const enum FEATURES {
	ADMAN_HANDLE_LINK = 'adman-handle-link',
	ADMAN_HANDLE_ONLY_SPEC = 'adman-handle-only-spec',
	ADMAN_LOG_NOT_OUR_ADV = 'adman-log-not-our-adv',
	ADMAN_LOG_EMPTY_SLOT_DATA = 'adman-log-empty-slot-data',
	ADMAN_LOG_COMM_SLOT = 'adman-log-comm-slot',
	ADMAN_LOG_ERROR = 'adman-log-error',
}

export default getFeatures;
